var map = {
	"./_template.yaml": 23,
	"./binaryAdd.yaml": 24,
	"./binaryIncrement.yaml": 25,
	"./binaryMult.yaml": 26,
	"./busyBeaver3.yaml": 27,
	"./busyBeaver4.yaml": 28,
	"./copy1s.yaml": 29,
	"./divisibleBy3.yaml": 30,
	"./divisibleBy3Base10.yaml": 31,
	"./lengthMult.yaml": 32,
	"./matchBinaryStrings.yaml": 33,
	"./matchThreeLengths.yaml": 34,
	"./palindrome.yaml": 35,
	"./powersOfTwo.yaml": 36,
	"./repeat01.yaml": 37,
	"./unaryMult.yaml": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;



//////////////////
// WEBPACK FOOTER
// ./src/examples ./~/raw-loader!^\.\/.*\.yaml$
// module id = 42
// module chunks = 1